import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import d3 from 'd3';
import ReactFauxDOM from 'react-faux-dom';
import classNames from 'classnames';

import * as SparklineActions from 'actions/sparkline';

import { trendClass } from 'utils/trend';

if (process.env.NODE_ENV !== 'test') {
  require('./Sparkline.scss');
}

class Sparkline extends Component {
  static propTypes = {
    itemSector: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.array,
    width: PropTypes.number,
    height: PropTypes.number,
    open: PropTypes.number,
  };

  static defaultProps = {
    isFetching: true,
    data: [],
    width: 100,
    height: 25,
    open: null,
  };

  constructor(props) {
    super(props);

    this.actions = bindActionCreators(SparklineActions, this.props.dispatch);
  }

  componentDidMount() {
    this.actions.fetchData(this.props.itemSector);
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.isFetching !== this.props.isFetching ||
      nextProps.data.length !== this.props.data.length
    );
  }

  render() {
    const { data, height, width, item } = this.props;
    const { CLOSE: close, CHANGE_PCT: changePct } = item.values;
    const yValues = data.map(arr => arr[1]);

    const el = d3
      .select(ReactFauxDOM.createElement('svg'))
      .attr({ height, width, class: 'Sparkline' });

    const x = d3.scale
      .linear()
      .range([0, width])
      .domain(d3.extent(yValues, (d, i) => i));

    const y = d3.scale
      .linear()
      .range([height, 0])
      .domain(d3.extent([close].concat(yValues, d => d)));

    const line = d3.svg
      .line()
      .x((d, i) => x(i))
      .y(d => y(d));

    el.append('path')
      .datum(yValues)
      .attr({
        key: 'line',
        className: classNames('line', trendClass(changePct)),
        d: line,
      });

    const closeValues = yValues.map(() => close);

    if (close == null) {
      el.append('path')
        .datum(closeValues)
        .attr({
          key: 'close',
          className: 'close',
        });
    } else {
      const closeLine = d3.svg
        .line()
        .x((d, i) => x(i))
        .y(d => y(d));

      el.append('path')
        .datum(closeValues)
        .attr({
          key: 'close',
          className: 'close',
          d: closeLine,
        });
    }

    return el.node().toReact();
  }
}

function mapStateToProps(state, ownProps) {
  const { itemSector } = ownProps;
  if (!state.sparklines.has(itemSector)) {
    return { data: [], isFetching: false };
  }

  return state.sparklines.get(itemSector).toJS();
}

export default connect(mapStateToProps)(Sparkline);
